import ApiService from './../Api.service.js'

class MemberService extends ApiService {
  constructor (endpoint) {
    super(endpoint)
    this.name = endpoint
  }
}

export const memberService = new MemberService('members{/id}')



// WEBPACK FOOTER //
// ./src/services/Miembro/member.service.js